module.exports = __webpack_public_path__ + "img/word2.09f94bd8.webp";